<script lang="ts" setup>
import './form-alerts.scss';
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';
import { sleep } from '@/utils';

type alertProps = {
    type: string;
    content: string;
    in?: boolean | undefined;
};

let messages: any = ref([]);

onMounted(() => {
    messages.value = [];
});

const addMsg = async (object: alertProps) => {
    if(object.in){ messages.value = []; }
    messages.value.push(object);
    setTimeout(() => {
        removeMessage(object.content)
    }, 20000);

    await sleep(1000);
}

defineExpose({ addMsg });

function removeMessage(content: string){
    const findMessageIndex = messages.value.findIndex((item: alertProps) => item.content === content);
    messages.value.splice(findMessageIndex, 1);
}
</script>

<template src="./form-alerts.html"></template>